import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import CaseStudyTemplate from "../components/CaseStudy/CaseStudyTemplate";

const CaseStudy = ({ data }) => {
  const caseStudy = data.caseStudy.edges[0].node;

  const next = data.nextCaseStudy.edges[0].node;
  const nextCaseStudy = {
    title: next.titleNextCase.titleNextCase,
    shortDescription: next.shortDescription.shortDescription,
    path: next.slug,
    featuredImage: next.nextCaseStudyImage,
    name: next.name
  };

  return (
    <Layout>
      <CaseStudyTemplate
        helmet={
          <Helmet titleTemplate="%s | Case Study">
            <title>{`${caseStudy.headline.headline}`}</title>
            <meta name="description" content={`${caseStudy.description}`} />
          </Helmet>
        }
        name={caseStudy.name}
        headline={caseStudy.headline.headline}
        description={caseStudy.description.description}
        roles={caseStudy.ourRoles}
        progressColor={caseStudy.readProgressBarColor}
        gradientColor={{
          fromColor: caseStudy.titleGradientColorFromLeft,
          toColor: caseStudy.titleGradientColorToRightColor
        }}
        blocks={caseStudy.contentBlocks}
        nextCaseStudy={nextCaseStudy}
      />
    </Layout>
  );
};

export default CaseStudy;

export const pageQuery = graphql`
  query CaseStudyByID($id: String!, $nextId: String!) {
    # caseStudy: allContentfulCaseStudy(id: { eq: $id }) {
    #   headline
    #   description
    #   roles
    #   tags
    #   progressColor
    #   gradientColor {
    #     fromColor
    #     toColor
    #   }
    #   blocks {
    #     type
    #     mobileEmptySpace
    #     desktopEmptySpace
    #     category
    #     title
    #     paragraph
    #     image {
    #       childImageSharp {
    #         fluid(maxWidth: 2880, quality: 90) {
    #           ...GatsbyImageSharpFluid_withWebp
    #         }
    #       }
    #     }
    #     video {
    #       publicURL
    #     }
    #     images {
    #       childImageSharp {
    #         fluid(maxWidth: 2880, quality: 90) {
    #           ...GatsbyImageSharpFluid_withWebp
    #         }
    #       }
    #     }
    #   }
    # }
    caseStudy: allContentfulCaseStudy(filter: { id: { eq: $id } }) {
      edges {
        node {
          headline {
            headline
          }
          name
          description {
            description
          }
          ourRoles
          readProgressBarColor
          titleGradientColorFromLeft
          titleGradientColorToRightColor
          contentBlocks {
            __typename
            ... on ContentfulContentBlockText {
              title {
                title
              }
              paragraph {
                paragraph
              }
              categoryGradient {
                categoryGradient
              }
            }
            ... on ContentfulContentBlockImage {
              image {
                fluid(maxWidth: 2880, quality: 90) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
              imageMobile {
                fluid(maxWidth: 769, quality: 90) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
            }
            ... on ContentfulContentBlockEmptySpace {
              mobileSpaceInPixels
              desktopSpaceInPixels
            }
            ... on ContentfulContentBlockVideo {
              video {
                file {
                  url
                }
              }
              videoMobile {
                file {
                  url
                }
              }
            }
            ... on ContentfulContentBlockCarousel {
              images {
                fluid(maxWidth: 2880, quality: 90) {
                  ...GatsbyContentfulFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
    nextCaseStudy: allContentfulCaseStudy(filter: { id: { eq: $nextId } }) {
      edges {
        node {
          name
          titleNextCase {
            titleNextCase
          }
          slug
          shortDescription {
            shortDescription
          }
          nextCaseStudyImage {
            fluid(maxWidth: 2880, quality: 90) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
